import { gql } from '@apollo/client/core';

export const FETCH_TRUSTED_CAREGIVER = gql`
  query TrustedCaregiver {
    trustedCaregiver {
      onboardingStatus
      checklist {
        type
        status
      }
    }
  }
`;
